/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PaymentLinkLineItemImageMetadata = {
  /**
   * Unique identifier for a image resource.
   */
  imageID: string;
  /**
   * Alternative text for the image.
   */
  altText?: string | undefined;
  /**
   * The image's public URL.
   */
  link: string;
  /**
   * A unique identifier for an image, used in public image links.
   */
  publicID: string;
};

/** @internal */
export const PaymentLinkLineItemImageMetadata$inboundSchema: z.ZodType<
  PaymentLinkLineItemImageMetadata,
  z.ZodTypeDef,
  unknown
> = z.object({
  imageID: z.string(),
  altText: z.string().optional(),
  link: z.string(),
  publicID: z.string(),
});
/** @internal */
export type PaymentLinkLineItemImageMetadata$Outbound = {
  imageID: string;
  altText?: string | undefined;
  link: string;
  publicID: string;
};

/** @internal */
export const PaymentLinkLineItemImageMetadata$outboundSchema: z.ZodType<
  PaymentLinkLineItemImageMetadata$Outbound,
  z.ZodTypeDef,
  PaymentLinkLineItemImageMetadata
> = z.object({
  imageID: z.string(),
  altText: z.string().optional(),
  link: z.string(),
  publicID: z.string(),
});

export function paymentLinkLineItemImageMetadataToJSON(
  paymentLinkLineItemImageMetadata: PaymentLinkLineItemImageMetadata,
): string {
  return JSON.stringify(
    PaymentLinkLineItemImageMetadata$outboundSchema.parse(
      paymentLinkLineItemImageMetadata,
    ),
  );
}
export function paymentLinkLineItemImageMetadataFromJSON(
  jsonString: string,
): SafeParseResult<PaymentLinkLineItemImageMetadata, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PaymentLinkLineItemImageMetadata$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PaymentLinkLineItemImageMetadata' from JSON`,
  );
}
